import React from 'react'
import { useSingleStreetLight } from '../../../../hooks'
import StreetLightNumberView from './StreetLightNumberView/StreetLightNumberView'

export default function StreetLightNumberPresenter() {
  const { singleStreetLightQuery:{data} } = useSingleStreetLight()
  return (
   <StreetLightNumberView number={data?.str_light_number} />
  )
}
